import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { NitroIcon } from 'nitro-components';

import { MenuRow, MenuRowHeader } from './styles';

const AccordionContent = styled.div`
  display: ${props => (props.open ? 'flex' : 'none')};
  flex-direction: column;
  width: ${props => props.width};
`;

const AccordionTitle = styled.span`
  flex-grow: 1;
`;

/**
 * Display content within a collapsible accordion.
 */
class Accordion extends React.Component {
  render() {
    const { icon, title, active, open, width, toggle } = this.props;
    const accordionIcon = `accordion-${open ? 'up' : 'down'}`;

    return (
      <MenuRow active={active}>
        <MenuRowHeader onClick={toggle} active={active} width={width}>
          <NitroIcon name={icon} variant="white" size={14} right={23} />
          <AccordionTitle>{title}</AccordionTitle>
          <NitroIcon name={accordionIcon} size={12} variant="white" />
        </MenuRowHeader>
        <AccordionContent open={open} width={width}>
          {this.props.children}
        </AccordionContent>
      </MenuRow>
    );
  }
}

Accordion.propTypes = {
  // The name of the icon to associate with the content of the accordion.
  icon: PropTypes.string.isRequired,

  // The text describing the content within the accordion.
  title: PropTypes.string.isRequired,

  // `true` if the accordion should be displayed as an actively selected menu item.
  active: PropTypes.bool,

  // `true` if the accordion should be openS
  open: PropTypes.bool,

  // Callback when the open state of the accordion should change
  toggle: PropTypes.func,

  // The width of the Accordion
  width: PropTypes.string.isRequired
};

Accordion.defaultProps = {
  active: false,
  open: false,
  toggle: () => {}
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/common/Menu/Sidebar/Accordion.js